<template>
  <div class="operatore">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "OperatoreMain",
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
  created() {
    if (this.user.type !== 1 || !this.user.all_consenses) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>